import { ApiClientV2, Client } from '../clients';

export class VisitorsClient {
  async getSettingsVisitors(officeId) {
    try {
      return await ApiClientV2.get(`/visitors/types-and-purposes`);
    } catch (error) {
      throw error;
    }
  }

  async getVisitors(params) {
    try {
      return await ApiClientV2.get(`/admin/visitors/log`, params);
    } catch (error) {
      throw error;
    }
  }
  async createVisitor(params) {
    try {
      return await ApiClientV2.post(`/admin/visitors`, params);
    } catch (error) {
      throw error;
    }
  }

  async getOffices() {
    try {
      return await Client.get('/v1/offices');
    } catch (error) {
      throw error;
    }
  }

  async getLegalDocsSigning(params) {
    try {
      return await ApiClientV2.get('/admin/legal-documents/signing', params);
    } catch (error) {
      throw error;
    }
  }

  async signVisitorsLegalDoc(documentUuid, params) {
    try {
      await ApiClientV2.post(`/legal-documents/${documentUuid}/sign`, params);
    } catch (error) {
      throw error;
    }
  }
}
